module.exports = "//a.spikex.com/sigma/frontend-ssr-web-index/_next/static/images/bg-55b804b0f73e2066e6267cce481be4c5.png";